import React from 'react';

import './src/styles/global.css';
import { CurrencyProvider } from './src/context/currencyContext';

export const wrapRootElement = ({ element }) => (
  <CurrencyProvider>{element}</CurrencyProvider>
);
